<template>
  <modal
    title="Add a new Idea List"
    :show="show"
    submit-button-text="Add this Idea List"
    ref="modal"
    :is-submitting="isSubmitting"
    @submit="onSubmit"
    @hidden="$emit('input', false)"
  >
    <div class="text-secondary text-normal">
      Use idea lists to brainstorm initiatives which will move your Goals. Then choose the best
      ideas to work on.
    </div>
    <form @submit.prevent="onSubmit">
      <div class="d-flex flex-column my-4">
        <label class="text-normal">Idea list Name</label>
        <input
          class="input-field text-normal idea-list-name rounded-edge mx-n2"
          :class="{ 'errored-field': errors.name }"
          type="text"
          v-model="formData.name"
          v-autofocus
        />
        <template v-if="errors.name">
          <div v-for="(error, index) in errors.name" :key="index" class="field-error-message">
            {{ error }}
          </div>
        </template>
        <span class="text-secondary mt-2"
          >e.g. Growth Ideas, Retention Ideas, Customer requests</span
        >
      </div>
      <div v-if="typeof errors === 'string'" class="field-error-message">
        {{ errors }}
      </div>
    </form>
  </modal>
</template>

<script>
import * as R from 'ramda'
import Modal from '@/components/Modal'
import EventBus from '@/EventBus'
import { mapActions } from 'vuex'

/**
 * This component provides functionality to create an IdeaList
 * @emits:
 * - created
 */
export default {
  name: 'IdeaListCreator',
  props: ['show', 'orgId', 'teamId', 'ideaList'],
  model: {
    prop: 'show'
  },
  components: {
    Modal
  },
  data() {
    return {
      formData: {},
      errors: {},
      isSubmitting: false
    }
  },
  methods: {
    ...mapActions('idea', ['createIdeaList']),
    async onSubmit() {
      try {
        // create idea list
        this.isSubmitting = true
        const response = await this.createIdeaList({
          orgId: this.orgId,
          name: this.formData.name,
          teamId: this.teamId
        })
        EventBus.$emit('ADD_TOAST', { message: 'New Idea list has been created successfully' })
        this.$emit('created', response.data)
        this.$refs.modal.hide()
      } catch (e) {
        this.errors = R.pathOr({}, ['response', 'data', 'detail'], e)
      }
      this.isSubmitting = false
    }
  },
  watch: {
    show(show) {
      if (show) {
        this.formData = {
          name: ''
        }
      } else {
        this.errors = {}
      }
    }
  },
  mounted() {
    EventBus.$on('SUBMIT_FORM', () => {
      this.show && this.onSubmit()
    })
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/forms';
@import '~@/styles/errors';

.idea-list-name {
  padding-top: 7px;
  padding-bottom: 7px;
}
</style>
